<template>
  <div class="td-login-blue4">
    <div class="td-login-blue4_logo"> </div>
    <div class="td-login-blue4_title"> </div>
    <div class="td-login-blue4_main">
      <div class="td-form-login">
        <div class="td-form-login_wrap">
          <el-form ref="formRef" :model="model" size="large" :rules="rules" label-position="left" @submit.native.prevent>
            <el-form-item v-if="showTenant_" prop="tenantId">
              <el-input v-model="model.tenantId" prefix-icon="el-icon-key" placeholder="请输入租户" clearable @change="tenantChange"> </el-input>
            </el-form-item>
            <el-form-item
              v-if="deptData.length > 0"
              prop="dept"
              :rules="{
                required: true,
                message: '请选择部门',
                trigger: 'change'
              }"
            >
              <template #label>
                <i class="iconfont ui-amy-aptitude"></i>
              </template>
              <td-select v-model="model.dept" :data="deptData" :prop="{ label: 'deptName', key: 'id' }"> </td-select>
            </el-form-item>
            <el-form-item prop="username">
              <el-input v-model="model.username" prefix-icon="el-icon-stamp" placeholder="请输入用户名"> </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="model.password" type="password" prefix-icon="el-icon-lock" placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item v-if="showCaptcha" prop="captchaCode">
              <td-captcha-input ref="captchaRef" v-model="model.captchaCode"></td-captcha-input>
            </el-form-item>
          </el-form>
          <el-button size="large" type="primary" :loading="loading" style="margin-top: 10px; width: 100%" @click="tryLogin">{{
            loading ? '登录中...' : '登录系统'
          }}</el-button>
        </div>
      </div>
    </div>

    <div class="copyright">技术支持：{{ copyright }} </div>
  </div>
</template>
<script setup>
import { onMounted, ref, computed } from 'vue'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
let store = useStore()
const { title, logo, unitName } = store.state.app.system
const formRef = ref(null)
const captchaRef = ref(null)
let gotoPage = null
let loginFlag = ref(false)
const showLogin = ref(true)
const deptData = ref([])
const copyright = computed(() => TdUI.getConfig('copyright') || '南京腾迪智能科技有限公司')
const goBack = () => {
  formRef.value.validate(valid => {
    if (valid) {
      store.commit('app/system/setDeptId', model.dept)
      store.dispatch('app/system/refreshToken').then(result => {
        gotoPage(result)
      })
    }
  })
}
//登录成功后回调
const loginCallback = async (result, go) => {
  if (result.code == 400) {
    ElMessage.warning('账号或密码错误')
    model.captchaCode = ''
    captchaRef.value.refresh()
    return
  }
  let deptResult = await $http.get(`td-system/dept/select?userId=${result.user_id}`, null, {
    headers: { 'blade-auth': `bearer ${result.access_token}` }
  })
  if (deptResult.code == 200) {
    if (deptResult.data.length > 0) {
      if (deptResult.data.length == 1) {
        let data = deptResult.data[0]
        store.commit('app/system/setDeptId', data.id)

        go()
        return
      } else {
        ElMessage.warning('请选择登录的部门')
        store.commit('app/system/setRefreshToken', result.refresh_token)
        deptData.value = deptResult.data
        loginFlag.value = true
        gotoPage = go
      }
    }
  }
}
const { model, rules, loading, tryLogin, tenantChange, showCaptcha, showTenant_ } = TdUI.composables.useLogin(formRef, captchaRef, loginCallback)
</script>
<script>
export default {
  name: 'LoginBlue4',
  cname: '环保部登录2'
}
</script>
<style lang="scss">
@import './_index';
</style>
